import { useCallback, useState } from 'react';

import { DEFAULT_REVEAL_CHARS_PER_SECOND, TRevealPlan, useRevealEngine } from './useRevealEngine.hook';

// Reveals plain text character by character.
export const useTypingRevealText = (sourceText: string, charsPerSecond: number = DEFAULT_REVEAL_CHARS_PER_SECOND) => {
  const [text, setText] = useState('');

  const createPlan = useCallback((source: string): TRevealPlan | null => {
    if (!source) {
      setText('');
      return null;
    }

    const totalChars = source.length;
    const reveal = (charsToShow: number) => {
      setText(source.slice(0, Math.max(0, Math.min(totalChars, charsToShow))));
    };

    return { totalChars, reveal };
  }, []);

  const { isAnimating, complete } = useRevealEngine(sourceText, createPlan, charsPerSecond);
  return { text, isAnimating, complete };
};
